import { api } from "@/api";
import { toast } from "sonner";

const enc = encodeURIComponent;
const HTTP_CONFLICT = 409;

async function postCopy(monthKey, dayNum, force, sourceDay, sourceMonth) {
  const q = `force=${force}`
    + (sourceDay ? `&source=${sourceDay}` : "")
    + (sourceMonth ? `&source_month=${encodeURIComponent(sourceMonth)}` : "");
  return api.post(`/months/${enc(monthKey)}/days/${dayNum}/copy-previous?${q}`);
}

function handleCopyError(err, onForce) {
  if (err.response?.status === HTTP_CONFLICT) {
    if (window.confirm("Il giorno contiene già dati. Sovrascrivere con la copia?")) onForce();
    return;
  }
  toast.error(err.response?.data?.detail || "Errore copia");
}

export function useDayActions(monthKey, dayNum, load) {
  const copyPrevious = async (force = false, sourceDay = null, sourceMonth = null) => {
    try {
      const res = await postCopy(monthKey, dayNum, force, sourceDay, sourceMonth);
      const cross = res.data.source_month && res.data.source_month !== monthKey ? ` del mese ${res.data.source_month}` : "";
      toast.success(`Copiati ${res.data.copied_assignments} nominativi dal giorno ${String(res.data.source_day).padStart(2, "0")}${cross} (stato blu)`);
      load();
    } catch (err) {
      handleCopyError(err, () => copyPrevious(true, sourceDay, sourceMonth));
    }
  };

  const saveBaseLists = async (personnel, sites, subs) => {
    try {
      await api.put(`/months/${enc(monthKey)}/days/${dayNum}/base-list`, { names: personnel });
      await api.put(`/months/${enc(monthKey)}/days/${dayNum}/base-sites`, { names: sites });
      await api.put(`/months/${enc(monthKey)}/days/${dayNum}/base-subcontractors`, { names: subs });
      toast.success("Liste base aggiornate");
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore salvataggio liste");
      throw err;
    }
  };

  const addSite = async (name) => {
    if (!name?.trim()) return;
    try {
      await api.post(`/months/${enc(monthKey)}/days/${dayNum}/sites`, { name });
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Errore"); }
  };

  return { copyPrevious, saveBaseLists, addSite };
}
